import { render, staticRenderFns } from "./CategoriaCamara.vue?vue&type=template&id=88a4af72&scoped=true"
import script from "./CategoriaCamara.vue?vue&type=script&lang=js"
export * from "./CategoriaCamara.vue?vue&type=script&lang=js"
import style0 from "./CategoriaCamara.vue?vue&type=style&index=0&id=88a4af72&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88a4af72",
  null
  
)

export default component.exports